import React from "react";
import Textfield from "../Input/Textfield";
import { useFormContext } from "react-hook-form";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import { DeliveryMethods } from "@/shared/utils/enum";
import usePosSettingsHook from "@/shared/hooks/usePosSettingsHook";
import useCountryConfigHook from "@/shared/hooks/useCountryConfigHook";
import { useTranslation } from "react-i18next";
import usePosOrderUser from "@/shared/atoms/usePosOrderUser";

const Zipcode = () => {
  const { t } = useTranslation();
  const { register, errors } = useFormContext();
  const [orderUser] = usePosOrderUser();
  const [deliveryMethodId] = usePosOrderDeliveryMethod();
  const {
    settings: { accept_all_addresses },
  } = usePosSettingsHook();
  const {
    address: { zipCodePattern },
    isTurkiye,
  } = useCountryConfigHook();

  const isRequiredForDelivery =
    deliveryMethodId === DeliveryMethods.DELIVERY &&
    !accept_all_addresses &&
    !isTurkiye;

  return (
    <Textfield
      ref={register({
        required: {
          value: isRequiredForDelivery,
          message: t("fieldRequired"),
        },
        pattern: {
          value: zipCodePattern,
          message: t("posOrders.zipcodeIsNotValid"),
        },
      })}
      isRequired={isRequiredForDelivery}
      defaultValue={orderUser?.zip_code?.replace(/\s/g, "")}
      error={errors.order_user?.zip_code?.message}
      label={t("posOrders.zipcode")}
      name="order_user.zip_code"
    />
  );
};

export default Zipcode;
